import * as React from 'react'

import type { Collection } from 'modules/core/lib/mobx-rest'

import type { ShiftVersionHistories } from 'modules/attendance/store/collections/shiftVersionHistories'
import type ShiftVersionHistory from 'modules/attendance/store/models/ShiftVersionHistory'

const Context = React.createContext<ShiftVersionHistories | null | undefined>(null)

export const ShiftVersionHistoriesProvider = ({
  collection,
  children,
}: {
  collection: Collection<ShiftVersionHistory>
  children: React.ReactNode
}) => <Context.Provider value={collection as any}>{children}</Context.Provider>

export const useShiftVersionHistories = (): ShiftVersionHistories => {
  const shiftVersionHistories = React.useContext(Context)

  if (!shiftVersionHistories) {
    throw new Error('useShiftVersionHistories must be used within a ShiftVersionHistoriesProvider')
  }

  return shiftVersionHistories
}
